define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    var FilePreviewDialogViewController = ViewController.extend({
        ControllerName: 'FilePreviewDialogViewController',

        LPViewMap: {
            dialog: '.lpview_file_preview_dialog',
            fileName: '.lpview_file_name',
            wrapper: '.lpview_file_preview_wrapper',
            chatInput: '.lpview_chat_input',
            closeButton: '.lpview_close_file_preview_dialog',
            sendButton: '.lpview_file_preview_send_button',
            cancelButton: '.lpview_file_preview_cancel_button'
        },

        initialize: function (data) {
            this.file = data.file;
            this.name = data.name;
            this.callback = data.callback;
            this.visitorId = data.visitorId;
            this.chatId = data.chatId;
            this.initView();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.cancelledClicked});
            this.bindViewEvent({selector: this.LPViewMap.sendButton , DOMEvent: "click", callback: this.sendClicked});
            this.bindViewEvent({selector: this.LPViewMap.cancelButton , DOMEvent: "click", callback: this.cancelledClicked});
        },

        render: function () {
            var callback = _setImage.bind(this);
            setTimeout(callback, 500);
            // _setImage.call(this);
        },
    });

    FilePreviewDialogViewController.prototype.initView = function() {
        var template = require('web-agent-templates/LP_file_preview_dialog.html');
        this.createView({template: template, wrapWithDiv: false});
    };

    FilePreviewDialogViewController.prototype.showDialog = function () {
        this.lpShow();
    };

    FilePreviewDialogViewController.prototype.hideDialog = function () {
        this.lpHide();
    };

    FilePreviewDialogViewController.prototype.sendClicked = function () {
        var caption = this.getFirstElement(this.LPViewMap.chatInput).value || '';
        _clearCaption.call(this);
        this.modelController.sendFile({file: this.file, chatId: this.chatId, visitorId: this.visitorId, caption: caption, callback: this.callback});
        this.hideDialog();
    };

    FilePreviewDialogViewController.prototype.cancelledClicked = function () {
        _clearCaption.call(this);
        this.hideDialog();
    };

    FilePreviewDialogViewController.prototype.dispose = function() {
        ViewController.prototype.dispose.call(this);
    };

    FilePreviewDialogViewController.prototype.setFile = function (file, name, callback) {
        this.file = file;
        this.name = name;
        this.callback = callback;
        _setImage.call(this);
        this.showDialog();
    };

    function _setImage() {
        var fileNameElement = this.getFirstElement(this.LPViewMap.fileName);
        var imageElement = this.getFirstElement(this.LPViewMap.wrapper);
        fileNameElement.innerText = this.name;
        var reader = new FileReader();
        var img = new Image();

        reader.onloadend = function () {
            img.src = reader.result;

            img.onload = function () {
                imageElement.style['background-image'] = 'url(\'' + reader.result + '\')';
            };
        };

        reader.readAsDataURL(this.file);
    }

    function _clearCaption() {
        var captionInput = this.getFirstElement(this.LPViewMap.chatInput);
        if (captionInput) {
            captionInput.value = '';
        }
    }

    return FilePreviewDialogViewController;
});
